import React from 'react';
import PropTypes from 'react-proptypes';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './icon.scss';

const getCode = code => String.fromCharCode(parseInt(code, 16));

const Icon = ({
    code,
    color,
    style,
    size,
    className,
    circle,
    ...rest
}) => (
    <div
        style={{
            color,
            fontSize: size,
            border: circle ? `2px solid ${color}` : null,
            borderRadius: circle ? '50%' : null,
            width: circle ? size * 2 : null,
            height: circle ? size * 2 : null,
            ...style,
        }}
        className={classnames('Icon', className)}
        // data-code={getCode(code)}
        {...rest}
    >
        <FontAwesomeIcon icon={code} />
    </div>
);

Icon.propTypes = {
    code: PropTypes.string.isRequired,
    color: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    size: PropTypes.number,
    circle: PropTypes.bool,
};

Icon.defaultProps = {
    color: '#000000',
    style: {},
    className: '',
    size: 12,
    circle: false,
};

export default Icon;
